<div>
  <ng-template libCustomHost></ng-template>
</div>
<div class="row" *ngIf="product?.subProductIds && showConceptDetails">
  <div class="col-12">
    <lib-filter-list #conceptList [configService]="configService"></lib-filter-list>
  </div>
</div>
